import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
  postQueryBodyWithCreator,
} from "../../../utils/reduxHelper";
import {
  hideToastNotification,
  showToastNotification,
} from "../../../redux/redux";
import { store } from "../../../redux/redux";

export const sourcingWishlistReduxAPI = createApi({
  reducerPath: "sourcingWishlistReduxAPI",
  baseQuery: baseQueryWithArgs,

  tagTypes: ["getWishlistProducts", "addWishlistProduct"],

  endpoints: (builder) => ({
    //GET Queries
    getWishlistProducts: builder.query({
      query: (
        { brandSourcingBrandId, allBrandSourcing } = {
          brandSourcingBrandId: null,
          allBrandSourcing: null,
        }
      ) =>
        getQueryStringWithCreator(
          `s/fetchProductsFromWishlist?brandSourcingBrandId=${brandSourcingBrandId}&allBrandSourcing=${allBrandSourcing}`
        ),
      providesTags: ["getWishlistProducts"],
      invalidatesTags: [
        "addWishlistProduct",
        "removeWishlistProduct",
        "getWishlistProducts",
      ],
    }),

    // POST Queries
    addWishlistProducts: builder.mutation({
      query: (body) => ({
        url: "s/addProductToWishlist",
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
      invalidatesTags: [
        "addWishlistProduct",
        "removeWishlistProduct",
        "getWishlistProducts",
      ],
      onQueryStarted: async (
        { toast = true, ...arg },
        { dispatch, queryFulfilled }
      ) => {
        if (toast) {
          try {
            await queryFulfilled;
            showToast({
              variant: "add-to-wishlist",
              message: "Added to Saved Items!",
            });
          } catch {
            showToast({
              variant: "error",
              message: "Failed to add product to Saved Items!",
            });
          }
        }
      },
    }),
    removeWishlistProduct: builder.mutation({
      query: (body) => ({
        url: "s/removeProductFromWishlist",
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
      invalidatesTags: [
        "addWishlistProduct",
        "removeWishlistProduct",
        "getWishlistProducts",
      ],
      onQueryStarted: async (
        { toast = true, ...arg },
        { dispatch, queryFulfilled }
      ) => {
        if (toast) {
          try {
            await queryFulfilled;
            showToast({
              variant: "remove-from-wishlist",
              message: "Removed from Saved Items!",
            });
          } catch {
            showToast({
              variant: "error",
              message: "Failed to remove product from Saved Items!",
            });
          }
        }
      },
    }),
  }),
});

let timerId = null;
function showToast({ variant, message }) {
  store.dispatch(hideToastNotification());
  clearTimeout(timerId);
  store.dispatch(showToastNotification({ variant, message }));
  timerId = setTimeout(() => {
    store.dispatch(hideToastNotification());
  }, 3000);
}

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetWishlistProductsQuery,
  useLazyGetWishlistProductsQuery,
  useAddWishlistProductsMutation,
  useRemoveWishlistProductMutation,
} = sourcingWishlistReduxAPI;
